import ProductFilterToolbox from "@/components/ProductFilterToolbox.jsx";
import ProductCatalogGrid from "@/components/ProductCatalogGrid.jsx";
import HomeActiveOrders from "@/components/HomeActiveOrders.jsx";
import HomeWelcomeHero from "@/components/HomeWelcomeHero.jsx";
import { useAuth } from "@/auth/AuthContext.jsx";
import { useHomeActiveOrders } from "@/hooks/useHomeActiveOrders.js";
import "@/components/product-filter.css";
import "./home.css";

export default function HomePage({
    products,
    categories,
    draftFilters,
    onFiltersChange,
    onApplyFilters,
    onResetFilters,
    loading,
    loadingMore,
    sentinelRef,
    error
}) {
    const { isAuthenticated } = useAuth();
    const { orders: activeOrders, isCustomer, loaded: activeOrdersLoaded } = useHomeActiveOrders();
    const showActiveOrders = isCustomer && activeOrdersLoaded && activeOrders.length > 0;
    const showWelcomeHero = !isAuthenticated || (activeOrdersLoaded && activeOrders.length === 0);

    return (
        <main>
            <section className="container catalog-section">
                {showActiveOrders && (
                    <HomeActiveOrders orders={activeOrders} />
                )}
                {showWelcomeHero && <HomeWelcomeHero />}
                <div className="catalog-with-filters">
                    <ProductFilterToolbox
                        filters={draftFilters}
                        categories={categories}
                        loading={loading && !loadingMore}
                        onChange={onFiltersChange}
                        onApply={onApplyFilters}
                        onReset={onResetFilters}
                    />

                    <div className="catalog-results" data-tour="catalog-results">
                        {loading && <p className="muted">Chargement des produits...</p>}
                        {error && <p className="error">{error}</p>}

                        {!loading && !error && products.length === 0 && (
                            <p className="muted">Aucun produit ne correspond à votre recherche.</p>
                        )}

                        <ProductCatalogGrid products={products} showHighlightStrips showPartnerSitePromo catalogLayout />

                        {loadingMore && <p className="muted catalog-loading-more">Chargement de la suite...</p>}
                        <div ref={sentinelRef} className="catalog-scroll-sentinel" aria-hidden="true" />
                    </div>
                </div>
            </section>
        </main>
    );
}
